import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface NotificationModel {
  notificationId: number;
  userId: number;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  isRead: boolean;
  createdAt: string;
  readAt?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {
  private http = inject(HttpClient);
  private unreadCountSubject = new BehaviorSubject<number>(0);

  public unreadCount$ = this.unreadCountSubject.asObservable();

  getUnreadNotifications(): Observable<NotificationModel[]> {
    return this.http.get<NotificationModel[]>(`${environment.apiEndPoint}api/Notification/unread`);
  }

  getUnreadCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${environment.apiEndPoint}api/Notification/unread/count`).pipe(
      tap(result => this.unreadCountSubject.next(result.count))
    );
  }

  markAsRead(notificationId: number): Observable<any> {
    return this.http.put(`${environment.apiEndPoint}api/Notification/${notificationId}/mark-read`, {}).pipe(
      tap(() => {
        const currentCount = this.unreadCountSubject.value;
        this.unreadCountSubject.next(Math.max(0, currentCount - 1));
      })
    );
  }

  markAllAsRead(): Observable<any> {
    return this.http.put(`${environment.apiEndPoint}api/Notification/mark-all-read`, {}).pipe(
      tap(() => {
        this.unreadCountSubject.next(0);
      })
    );
  }

  incrementUnreadCount(): void {
    const currentCount = this.unreadCountSubject.value;
    this.unreadCountSubject.next(currentCount + 1);
  }

  refreshUnreadCount(): void {
    this.getUnreadCount().subscribe({
      error: (error) => {
        console.error('Error fetching unread count:', error);
        this.unreadCountSubject.next(0);
      }
    });
  }
}
